var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-content"},[_c('div',{staticClass:"container"},[_c('ct-faq-service-content'),_c('ct-faq-support-content'),_c('ct-faq-pague-com-bitcoin-content'),_c('ct-faq-general-info-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }